import CardWorkshop from '../../../components/cards/card-workshop/CardWorkshop';
import { WorkshopDisplay } from '../../../models/auto-generated-strapi-types/types/components/WorkshopDisplay';
import SectionHeader from '../../generic/section-header/SectionHeader';
import {
  ButtonWrapper,
  CardsWrapper,
  InnerWrapper,
  OuterWrapper,
} from './WorkshopDisplay.style';
import Button, { ButtonStyle } from '../../../components/button/Button';
import { Slug } from '../../../models/domain/interfaces';
import {
  WorkshopNormalized,
  normalizeAttributesWorkshopsSliders,
} from '../../../utils/workshops';
import { getWorkshops } from '../../../utils/api';
import { Pages } from '../../../models/domain/enum';
import Link from 'next/link';
import { Logger } from 'corporate-utils';

export interface WorkshopDisplayProps extends WorkshopDisplay {
  cards: WorkshopNormalized[];
}

const WorkshopDisplaySection: React.FC<any> = ({
  data,
  isPrerenderRequest,
}: {
  data: WorkshopDisplayProps;
  isPrerenderRequest: boolean;
}) => {
  return (
    <OuterWrapper color={data?.backgroundColor}>
      <InnerWrapper>
        {data?.sectionHeader && (
          <SectionHeader
            data={data.sectionHeader}
            isPrerenderRequest={isPrerenderRequest}
          />
        )}
        <CardsWrapper>
          {data?.cards?.map((card) => {
            return (
              <CardWorkshop
                isPrerenderRequest={isPrerenderRequest}
                data={card}
                personalization={data?.cardPersonalization}
              />
            );
          })}
        </CardsWrapper>
        {data?.button && data?.button?.url && data?.button.text && (
          <ButtonWrapper>
            <Link href={data.button.url} passHref>
              <Button
                text={data?.button?.text}
                styleBtn={data?.button.type as ButtonStyle | undefined}
                asA={true}
              />
            </Link>
          </ButtonWrapper>
        )}
      </InnerWrapper>
    </OuterWrapper>
  );
};

export default WorkshopDisplaySection;

export const getServerSideProps = async (
  section: any,
  translations: any,
  slugAnalyzed: Slug,
  isPrerenderRequest: boolean
) => {
  let pageSize = undefined;

  switch (slugAnalyzed.type) {
    default:
    case Pages.HOME:
      pageSize = 3;
      break;

    case Pages.WORKSHOPS:
      pageSize = 999; // We have to show all workshops
      break;
  }

  let workshops: any[] = [];

  try {
    workshops = normalizeAttributesWorkshopsSliders(
      (
        await getWorkshops({
          locale: slugAnalyzed.locale,
          pageSize: pageSize,
          sort: ['publishedAt:desc'],
          datesFormat: translations?.date?.sliderNewsEvents?.format,
        })
      )?.data,
      translations,
      slugAnalyzed.locale,
      isPrerenderRequest
    );
  } catch (error) {
    Logger.error(error);
  }

  section.cards = workshops;
};
